var module = angular.module('octopusApp.infrastructure');
var _ = require('underscore');

// A service that helps to prompt for unsaved changes
//
//
module.factory('unsavedChanges', function ($rootScope, $location, octoDialog) {

    $rootScope.octopusUnsavedChanges = false;

    var instance = {};

    instance.hasUnsavedChanges = function () {
        return $rootScope.octopusUnsavedChanges;
    };

    instance.saved = function () {
        $rootScope.octopusUnsavedChanges = false;
        $rootScope.$broadcast('changesSaved', {});
    };

    instance.ignoreNextLocationChange = function () {
        // Ignore next location change.  Then reset.
        $rootScope.ignoreNextLocationChange = true;
    };

    instance.unsaved = function () {
        $rootScope.octopusUnsavedChanges = true;
    };

    $rootScope.$on("$stateChangeSuccess", function () {
        instance.saved();
    });

    var leave = false;
    $rootScope.$on('$locationChangeStart', function (event, next) {
        if (leave) {
            leave = false;
            return;
        }

        if ($rootScope.octopusUnsavedChanges && !$rootScope.ignoreNextLocationChange) {
            event.preventDefault();

            octoDialog.confirmChangesWillBeLost(function () {
                leave = true;

                $location.url($location.url(next).hash());
            });
        }

        if ($rootScope.ignoreNextLocationChange) {
            $rootScope.ignoreNextLocationChange = false; // Reset
        }
    });

    window.onbeforeunload = function (e) {
        if ($rootScope.octopusUnsavedChanges) {
            var message = "Unsaved changes will be lost.";
            var evt = e || window.event;
            if (evt) {
                evt.returnValue = message;
            }
            return message;
        }
    };

    return instance;
});





//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/unsaved_changes.js
// module id = 1319839884300419
// module chunks = 1